var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"switch",on:{"click":_vm.switchValue}},[_c('div',{class:['switch__switch', _vm.value && 'switch__switch--active']},[_c('div',{staticClass:"switch__switch__element"})]),(_vm.label)?_c('div',{staticClass:"switch__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }